/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Builtwith } from './Builtwith';
import {
    BuiltwithFromJSON,
    BuiltwithFromJSONTyped,
    BuiltwithToJSON,
} from './Builtwith';
import type { CRSFConfidenceData } from './CRSFConfidenceData';
import {
    CRSFConfidenceDataFromJSON,
    CRSFConfidenceDataFromJSONTyped,
    CRSFConfidenceDataToJSON,
} from './CRSFConfidenceData';
import type { CRSFEmailLeaksAggregatedResponse } from './CRSFEmailLeaksAggregatedResponse';
import {
    CRSFEmailLeaksAggregatedResponseFromJSON,
    CRSFEmailLeaksAggregatedResponseFromJSONTyped,
    CRSFEmailLeaksAggregatedResponseToJSON,
} from './CRSFEmailLeaksAggregatedResponse';
import type { CRSFFindingAggregated } from './CRSFFindingAggregated';
import {
    CRSFFindingAggregatedFromJSON,
    CRSFFindingAggregatedFromJSONTyped,
    CRSFFindingAggregatedToJSON,
} from './CRSFFindingAggregated';
import type { CRSFSourcelistsData } from './CRSFSourcelistsData';
import {
    CRSFSourcelistsDataFromJSON,
    CRSFSourcelistsDataFromJSONTyped,
    CRSFSourcelistsDataToJSON,
} from './CRSFSourcelistsData';
import type { CRSFSpidersAggregatedResponse } from './CRSFSpidersAggregatedResponse';
import {
    CRSFSpidersAggregatedResponseFromJSON,
    CRSFSpidersAggregatedResponseFromJSONTyped,
    CRSFSpidersAggregatedResponseToJSON,
} from './CRSFSpidersAggregatedResponse';
import type { CRSFWappalyzerAggregatedData } from './CRSFWappalyzerAggregatedData';
import {
    CRSFWappalyzerAggregatedDataFromJSON,
    CRSFWappalyzerAggregatedDataFromJSONTyped,
    CRSFWappalyzerAggregatedDataToJSON,
} from './CRSFWappalyzerAggregatedData';
import type { Enumerated } from './Enumerated';
import {
    EnumeratedFromJSON,
    EnumeratedFromJSONTyped,
    EnumeratedToJSON,
} from './Enumerated';
import type { RiskSummary } from './RiskSummary';
import {
    RiskSummaryFromJSON,
    RiskSummaryFromJSONTyped,
    RiskSummaryToJSON,
} from './RiskSummary';
import type { SourceCount } from './SourceCount';
import {
    SourceCountFromJSON,
    SourceCountFromJSONTyped,
    SourceCountToJSON,
} from './SourceCount';
import type { TechnologiesInner } from './TechnologiesInner';
import {
    TechnologiesInnerFromJSON,
    TechnologiesInnerFromJSONTyped,
    TechnologiesInnerToJSON,
} from './TechnologiesInner';
import type { Virustotal } from './Virustotal';
import {
    VirustotalFromJSON,
    VirustotalFromJSONTyped,
    VirustotalToJSON,
} from './Virustotal';

/**
 * 
 * @export
 * @interface CRSFAggregatedFindingsResponse
 */
export interface CRSFAggregatedFindingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CRSFAggregatedFindingsResponse
     */
    asm_domain?: boolean;
    /**
     * 
     * @type {Builtwith}
     * @memberof CRSFAggregatedFindingsResponse
     */
    builtwith: Builtwith;
    /**
     * 
     * @type {CRSFEmailLeaksAggregatedResponse}
     * @memberof CRSFAggregatedFindingsResponse
     */
    dataleaks: CRSFEmailLeaksAggregatedResponse;
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregatedFindingsResponse
     */
    domain?: string;
    /**
     * 
     * @type {CRSFConfidenceData}
     * @memberof CRSFAggregatedFindingsResponse
     */
    domain_confidence?: CRSFConfidenceData;
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregatedFindingsResponse
     */
    domain_origination?: string;
    /**
     * 
     * @type {Enumerated}
     * @memberof CRSFAggregatedFindingsResponse
     */
    enumerated: Enumerated;
    /**
     * 
     * @type {Array<CRSFFindingAggregated>}
     * @memberof CRSFAggregatedFindingsResponse
     */
    findings: Array<CRSFFindingAggregated>;
    /**
     * 
     * @type {RiskSummary}
     * @memberof CRSFAggregatedFindingsResponse
     */
    risk_summary: RiskSummary;
    /**
     * 
     * @type {SourceCount}
     * @memberof CRSFAggregatedFindingsResponse
     */
    source_count: SourceCount;
    /**
     * 
     * @type {CRSFSourcelistsData}
     * @memberof CRSFAggregatedFindingsResponse
     */
    sourcelists: CRSFSourcelistsData;
    /**
     * 
     * @type {CRSFSpidersAggregatedResponse}
     * @memberof CRSFAggregatedFindingsResponse
     */
    spiders: CRSFSpidersAggregatedResponse;
    /**
     * 
     * @type {Array<TechnologiesInner>}
     * @memberof CRSFAggregatedFindingsResponse
     */
    technologies: Array<TechnologiesInner>;
    /**
     * 
     * @type {Virustotal}
     * @memberof CRSFAggregatedFindingsResponse
     */
    virustotal: Virustotal;
    /**
     * 
     * @type {Array<CRSFWappalyzerAggregatedData>}
     * @memberof CRSFAggregatedFindingsResponse
     */
    wappalyzer?: Array<CRSFWappalyzerAggregatedData>;
}

/**
 * Check if a given object implements the CRSFAggregatedFindingsResponse interface.
 */
export function instanceOfCRSFAggregatedFindingsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "builtwith" in value;
    isInstance = isInstance && "dataleaks" in value;
    isInstance = isInstance && "enumerated" in value;
    isInstance = isInstance && "findings" in value;
    isInstance = isInstance && "risk_summary" in value;
    isInstance = isInstance && "source_count" in value;
    isInstance = isInstance && "sourcelists" in value;
    isInstance = isInstance && "spiders" in value;
    isInstance = isInstance && "technologies" in value;
    isInstance = isInstance && "virustotal" in value;

    return isInstance;
}

export function CRSFAggregatedFindingsResponseFromJSON(json: any): CRSFAggregatedFindingsResponse {
    return CRSFAggregatedFindingsResponseFromJSONTyped(json, false);
}

export function CRSFAggregatedFindingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFAggregatedFindingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asm_domain': !exists(json, 'asm_domain') ? undefined : json['asm_domain'],
        'builtwith': BuiltwithFromJSON(json['builtwith']),
        'dataleaks': CRSFEmailLeaksAggregatedResponseFromJSON(json['dataleaks']),
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'domain_confidence': !exists(json, 'domain_confidence') ? undefined : CRSFConfidenceDataFromJSON(json['domain_confidence']),
        'domain_origination': !exists(json, 'domain_origination') ? undefined : json['domain_origination'],
        'enumerated': EnumeratedFromJSON(json['enumerated']),
        'findings': ((json['findings'] as Array<any>).map(CRSFFindingAggregatedFromJSON)),
        'risk_summary': RiskSummaryFromJSON(json['risk_summary']),
        'source_count': SourceCountFromJSON(json['source_count']),
        'sourcelists': CRSFSourcelistsDataFromJSON(json['sourcelists']),
        'spiders': CRSFSpidersAggregatedResponseFromJSON(json['spiders']),
        'technologies': ((json['technologies'] as Array<any>).map(TechnologiesInnerFromJSON)),
        'virustotal': VirustotalFromJSON(json['virustotal']),
        'wappalyzer': !exists(json, 'wappalyzer') ? undefined : ((json['wappalyzer'] as Array<any>).map(CRSFWappalyzerAggregatedDataFromJSON)),
    };
}

export function CRSFAggregatedFindingsResponseToJSON(value?: CRSFAggregatedFindingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asm_domain': value.asm_domain,
        'builtwith': BuiltwithToJSON(value.builtwith),
        'dataleaks': CRSFEmailLeaksAggregatedResponseToJSON(value.dataleaks),
        'domain': value.domain,
        'domain_confidence': CRSFConfidenceDataToJSON(value.domain_confidence),
        'domain_origination': value.domain_origination,
        'enumerated': EnumeratedToJSON(value.enumerated),
        'findings': ((value.findings as Array<any>).map(CRSFFindingAggregatedToJSON)),
        'risk_summary': RiskSummaryToJSON(value.risk_summary),
        'source_count': SourceCountToJSON(value.source_count),
        'sourcelists': CRSFSourcelistsDataToJSON(value.sourcelists),
        'spiders': CRSFSpidersAggregatedResponseToJSON(value.spiders),
        'technologies': ((value.technologies as Array<any>).map(TechnologiesInnerToJSON)),
        'virustotal': VirustotalToJSON(value.virustotal),
        'wappalyzer': value.wappalyzer === undefined ? undefined : ((value.wappalyzer as Array<any>).map(CRSFWappalyzerAggregatedDataToJSON)),
    };
}

